module.exports = __webpack_public_path__ + "img/details-img-01.c476455d.png";